import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import axios from 'axios';

import type { TokenResponse } from '@react-oauth/google';
import { useGoogleLogin } from '@react-oauth/google';

import GoogleIcon from 'Assets/images/Google_icon.png';
import { logInOrSignUpViaGoogle } from 'Auth/data';
import { StyledButton } from 'Components/Styled';
import { useAppDispatch } from 'Store';

import type { ILogInOrSignUpViaGoogleRequest } from '@libs/models';

interface IDecodedResponse {
  email: string;
  email_verified: boolean;
  name: string;
  picture: string;
  given_name: string;
  family_name: string;
  locale: string;
  sub: string;
}

export const GoogleSimpleButton = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation();

  const handleOnSuccess = async (credentialResponse: TokenResponse) => {
    try {
      const response = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: {
          Authorization: `Bearer ${credentialResponse.access_token}`
        }
      });

      const userData = response.data as IDecodedResponse;

      const result = await dispatch(
        logInOrSignUpViaGoogle({
          email: userData.email,
          firstName: userData.given_name,
          lastName: userData.family_name
        } as ILogInOrSignUpViaGoogleRequest)
      ).unwrap();

      if (result.shouldNavigateTo) {
        navigate(result.shouldNavigateTo, { state: result.navigationState });
      }
    } catch (error) {
      console.error('Login via Google Failed', error);
    }
  };

  const handleOnError = error => console.error('Login via Google Failed', error);

  const googleLogin = useGoogleLogin({
    onSuccess: handleOnSuccess,
    onError: handleOnError
    // TODO: flow: 'auth-code',
  });

  const handleLogin = () => googleLogin();

  return (
    <StyledButton
      variant="outlined"
      startIcon={<img alt="Google Icon" src={GoogleIcon} />}
      onClick={handleLogin}
    >
      {t('auth.loginViaGoogle')}
    </StyledButton>
  );
};
